var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleUp = function SvgAngleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Angle-Up_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 12,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 9.998 4.622-5.021a.517.517 0 0 1 .754 0L13 9.998",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Angle-Up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgAngleUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIxODdfMjY3NyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMiIgeT0iNCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjciPgo8cGF0aCBkPSJNMi45OTkyNyA5Ljk5ODQxTDcuNjIyMzQgNC45NzY4OUM3LjY3MDY5IDQuOTI1MzggNy43MjkwOCA0Ljg4NDMzIDcuNzkzOSA0Ljg1NjI3QzcuODU4NzMgNC44MjgyIDcuOTI4NjMgNC44MTM3MiA3Ljk5OTI3IDQuODEzNzJDOC4wNjk5MSA0LjgxMzcyIDguMTM5OCA0LjgyODIgOC4yMDQ2MyA0Ljg1NjI3QzguMjY5NDYgNC44ODQzMyA4LjMyNzg1IDQuOTI1MzggOC4zNzYxOSA0Ljk3Njg5TDEyLjk5OTMgOS45OTg0MSIgc3Ryb2tlPSIjMTQxNjFBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8yMTg3XzI2NzcpIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjMTQxNjFBIi8+CjwvZz4KPC9zdmc+Cg==";